class GHeader extends HTMLElement {
  constructor() {
    super();

    this.announcementBar = this.querySelector(".js-announcement-bar");
    this.topNavDsk = this.querySelector(".js-top-nav-dsk");
    this.header = this.querySelector("header");
  }

  connectedCallback() {
    if (this.menuLazyload) {
      this._fetchMenu();
    }
    this._initHideScroll();
    window.matchMedia("(min-width: 1024px)").addEventListener("change", (e) => {
      this._calcScrollOffset();
      this._fetchMenu();
    });
  }

  _calcScrollOffset() {
    let scrollOffset = this.announcementBar?.offsetHeight ?? 0;
    if (window.innerWidth >= 1024) {
      scrollOffset += this.topNavDsk.offsetHeight;
    } else {
      scrollOffset += this.header.offsetHeight;
    }
    this.style.setProperty("--scroll-offset", -scrollOffset + "px");
  }

  async _fetchMenu() {
    const url =
      window.innerWidth < 1024
        ? "/search?sections=ajax-header-menu-mob"
        : "/search?sections=ajax-header-menu-dsk";
    const response = await fetch(url);
    const json = await response.json();
    const section = json[Object.keys(json)[0]];
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = section;
    const modalContainer = document.querySelector(".js-header-menu-container");
    const newModalContainer = tempDiv.querySelector(".js-header-menu-container");
    modalContainer.innerHTML = newModalContainer.innerHTML;
  }

  _initHideScroll() {
    this._calcScrollOffset();

    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollDiff = 0;
    let ticking = false;
    let previousDirection = "up";
    const scrollBegginThreshold = 100;
    const scrollThreshold = 150;

    function handleScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const direction = currentScroll > lastScrollTop ? "down" : "up";
      if (direction !== previousDirection) {
        scrollDiff = 0;
      }
      scrollDiff += Math.abs(currentScroll - lastScrollTop);

      if (currentScroll > scrollBegginThreshold) {
        if (scrollDiff > scrollThreshold) {
          if (direction === "down") {
            // Scrolling down
            this.classList.add("js-scroll");
          } else {
            // Scrolling up
            if(!window.disableScrollRemove) {
              this.classList.remove("js-scroll");
            }
          }
        }
      } else {
        this.classList.remove("js-scroll");
      }

      previousDirection = direction;
      lastScrollTop = Math.max(currentScroll, 0);
      ticking = false;
    }

    const handleScrollBinded = handleScroll.bind(this);

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(handleScrollBinded);
        ticking = true;
      }
    }

    const onScrollBinded = onScroll.bind(this);

    // Store actual value separately
    let _enableRetractableNav = window.enableRetractableNav || false;

    // Create a dynamic getter/setter on window
    Object.defineProperty(window, "enableRetractableNav", {
      get() {
        return _enableRetractableNav;
      },
      set(value) {
        _enableRetractableNav = value;

        if (value) {
          window.addEventListener("scroll", onScrollBinded, { passive: true });
        } else {
          window.removeEventListener("scroll", onScrollBinded);
          this.classList.remove("js-scroll");
        }
      },
    });
  }

  get menuLazyload() {
    return this.dataset.menuLazyload === "true";
  }
}

customElements.define("g-header", GHeader);
